import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { toast } from "sonner";

export default function Settings() {
  const { user } = useAuth();
  const [pw, setPw] = useState("");
  const [saving, setSaving] = useState(false);

  const changePw = async () => {
    if (pw.length < 6) return toast.error("Min 6 characters");
    setSaving(true);
    try {
      await api.put(`/users/${user.id}`, { password: pw });
      toast.success("Password updated");
      setPw("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-[#E1A104] font-semibold">Settings</div>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">Account</h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-6 max-w-xl space-y-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-gray-500">Name</div>
          <div className="text-sm font-semibold">{user?.name}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-gray-500">Email</div>
          <div className="text-sm font-semibold">{user?.email}</div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-gray-500">Role</div>
          <div className="text-sm font-semibold uppercase">{user?.role}</div>
        </div>

        {user?.role === "admin" && (
          <div className="pt-4 border-t border-gray-200">
            <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Change password</div>
            <div className="flex gap-2">
              <input type="password" value={pw} onChange={(e) => setPw(e.target.value)}
                placeholder="New password"
                data-testid="new-password-input"
                className="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm" />
              <button onClick={changePw} disabled={saving}
                data-testid="save-password-button"
                className="px-4 py-2 bg-[#1A3A21] hover:bg-[#142C19] text-white rounded-md text-sm">
                {saving ? "Saving..." : "Update"}
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-6 max-w-xl">
        <h3 className="font-display text-lg font-bold mb-3">About GARDAJ CRM</h3>
        <p className="text-sm text-gray-600 leading-relaxed">
          Built for the GARDAJ Distribution team to manage B2B hemp and CBD wholesale pipelines.
          Upcoming integrations: WordPress catalog and Danea Easyfatt stock data.
        </p>
      </div>
    </div>
  );
}
